import React from "react";
import { getMessageType } from "../../../Helpers/Utility";
import { getExtension } from "../Common/FileUploadValidation";
import getFileFromType from "../ConversationSection/Conversation/Templates/Common/getFileFromType";
import PreviewAudio from "./Audio";
import PreviewDocument from "./Document";
import Image from "./Image";
import PreviewVideo from "./Video";

const PreviewComponent = (selectedFiles,onChangeCaption,sendMediaFile,updateMedia) => {
  return selectedFiles.map((res, index) => {
    let fileType = res.type;
    let mediaType = getMessageType(res.type, res);
    const fileExtension = getExtension(res.name);

    const { fileDetails: { fileId } } = res;
    switch (mediaType) {
      case "image":
        return (
          <Image
            thumb={"image"}
            key={fileId}
            onClickSend={sendMediaFile}
            media={res}
          //   caption={caption}
          //   onClickCloseSelectedItem={props.onClickCloseSelectedItem}
            onChangeCaption={onChangeCaption}
          //   updateMedia={updateMedia}
          />
        );
      case "video":
        return (
          <PreviewVideo
            thumb={"video"}
            key={fileId}
            onClickSend={sendMediaFile}
            media={res}
            // caption={caption}
            // onClickCloseSelectedItem={this.props.onClickCloseSelectedItem}
            onChangeCaption={onChangeCaption}
            updateMedia={updateMedia}
          />
        );
      case "file":
        const placeholder = getFileFromType(fileType, fileExtension);
        return (
          <PreviewDocument
            thumb={"file"}
            key={fileId}
            onClickSend={sendMediaFile}
            media={res}
            // caption={caption}
            placeholder={placeholder}
            // onClickCloseSelectedItem={this.props.onClickCloseSelectedItem}
            onChangeCaption={onChangeCaption}
            // updateMedia={this.updateMedia}
          />
        );

      case "audio":
        return (
          <PreviewAudio
            thumb={"audio"}
            key={fileId}
            onClickSend={sendMediaFile}
            media={res}
            // caption={caption}
            // placeholder={placeholder}
            // onClickCloseSelectedItem={this.props.onClickCloseSelectedItem}
            onChangeCaption={onChangeCaption}
            updateMedia={updateMedia}
          />
        );
      }
    }
  )
}

export default PreviewComponent;